import { useNavigate } from 'react-router-dom';
import { useCreateCountry } from '@/hooks';
import { CreateCountryRequest } from '@/types/model';
import CountryForm from '@/components/forms/CountryForm';

const CreateCountry = () => {
  const navigate = useNavigate();
  const createCountryMutation = useCreateCountry();

  const handleSuccess = async (data: CreateCountryRequest) => {
    try {
      await createCountryMutation.mutateAsync(data);
      console.log('Country created successfully');
      navigate('/content/countries');
    } catch (error) {
      console.error('Create country error', error);
      throw error;
    }
  };

  const handleCancel = () => {
    navigate('/content/countries');
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <CountryForm
          onSuccess={handleSuccess}
          onCancel={handleCancel}
          isSubmitting={createCountryMutation.isPending}
        />
      </div>
    </div>
  );
};

export default CreateCountry;
